import React from 'react';
import { graphql } from 'gatsby';
import Container from '../../layout/container/container';
import Spacing from '../../layout/spacing/spacing';
import Content from '../../content/content';

const ContentBlock = ({ paddingTop, paddingBottom, background, ...props }) => {
  return (
    <Container gutters bg={background}>
      <Spacing pt={paddingTop} pb={paddingBottom}>
        <Content {...props} />
      </Spacing>
    </Container>
  );
};

export default ContentBlock;

export const query = graphql`
  fragment ContentBlock on DatoCmsContentBlock {
    id: originalId
    heading
    headingSize
    text
    side
    background
    internalLinkAnchor
    paddingBottom
    paddingTop
    anchor
    __typename
  }
`;
